"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agent = void 0;
var axios_1 = __importDefault(require("axios"));
var Result_1 = require("../../models/concrete/Result");
var HTTPError_1 = require("../../models/concrete/HTTPError");
var Agent = /** @class */ (function () {
    function Agent(baseUrl, headers, configProps) {
        this.transport = this.configureTransport(baseUrl, headers, configProps);
    }
    Agent.prototype.getConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_1, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get('/configs')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_1 = _a.sent();
                        response = ex_1.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentMenus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_2, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get('/cms/menus')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_2 = _a.sent();
                        response = ex_2.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentPage = function (pageSlug) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_3, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/page-by-path?path=".concat(pageSlug))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_3 = _a.sent();
                        response = ex_3.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentPageById = function (pageId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_4, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/page/".concat(pageId))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_4 = _a.sent();
                        response = ex_4.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentHomePage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_5, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/home")];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_5 = _a.sent();
                        response = ex_5.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.signUp = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_6, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/signup", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_6 = _a.sent();
                        response = ex_6.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.requestPassword = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_7, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/request", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_7 = _a.sent();
                        response = ex_7.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.signIn = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_8, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/login", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.token,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_8 = _a.sent();
                        response = ex_8.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getUser = function (expanded) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_9, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = '';
                        if (expanded) {
                            query = '?expand=group';
                        }
                        return [4 /*yield*/, this.transport.get("/sms-users/me".concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_9 = _a.sent();
                        response = ex_9.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.updateUser = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_10, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.put("/sms-users/me", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_10 = _a.sent();
                        response = ex_10.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.setUserAvatar = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response, ex_11, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formData = new FormData();
                        formData.append('avatar', data);
                        return [4 /*yield*/, this.transport.post("/sms-users/me/avatar", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        // const { data } = response;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_11 = _a.sent();
                        response = ex_11.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getSessionToken = function (headers) {
        return headers['x-session-token'] || '';
    };
    Agent.prototype.configureTransport = function (baseUrl, headers, configProps) {
        var axiosHeaders = __assign({}, headers || {});
        var axiosConfig = {};
        if (configProps === null || configProps === void 0 ? void 0 : configProps.cancelToken) {
            axiosConfig.cancelToken = configProps === null || configProps === void 0 ? void 0 : configProps.cancelToken;
        }
        var instance = axios_1.default.create(__assign({ baseURL: baseUrl, headers: axiosHeaders }, axiosConfig));
        return instance;
    };
    return Agent;
}());
exports.Agent = Agent;
//# sourceMappingURL=Agent.js.map